export interface IColor {
  value: string;
  themeIndex: number | null;
}

enum DefaultColorLabel {
  White = "#FFFFFF",
  Grey10 = "#F2F6F7",
  Grey25 = "#E0E8EC",
  Midnight = "#242C39",
  Grey = "#81A2B2",
}

export const DEFAULT_WHITE = {
  value: DefaultColorLabel.White,
  themeIndex: -1,
};

export const DEFAULT_GREY10 = {
  value: DefaultColorLabel.Grey10,
  themeIndex: -2,
};

export const DEFAULT_MIDNIGHT = {
  value: DefaultColorLabel.Midnight,
  themeIndex: -3,
};

export const DEFAULT_GREY = {
  value: DefaultColorLabel.Grey,
  themeIndex: -4,
};

export const DEFAULT_GREY25 = {
  value: DefaultColorLabel.Grey25,
  themeIndex: -5,
};

// These are the default colors that are available to users for most things
// E.g. text color, bar color (of pull quotes)
const defaultColors: IColor[] = [DEFAULT_MIDNIGHT, DEFAULT_GREY10, DEFAULT_WHITE];

// These are the default colors for table borders
export const defaultBorderColors: IColor[] = [DEFAULT_GREY, DEFAULT_MIDNIGHT, DEFAULT_WHITE];

// These are all the default colors that we use
export const allDefaultColors: IColor[] = [
  DEFAULT_GREY25,
  DEFAULT_GREY,
  DEFAULT_MIDNIGHT,
  DEFAULT_GREY10,
  DEFAULT_WHITE,
];

export default defaultColors;
